function getClosestMultipleOf(price, multipleOf) {
  return Math.ceil(price / multipleOf) * multipleOf;
}

/**
 * @param {number} price - amount that needs to be covered.
 */
export default function getBillsSuggestions(price) {
  const suggestions = new Set([
    10,
    50,
    200,
    getClosestMultipleOf(price, 100),
    getClosestMultipleOf(price, 500),
    getClosestMultipleOf(price, 1000),
    price,
    5000,
  ]);

  return [...suggestions]
    .filter(suggestion => suggestion >= price)
    .sort((a, b) => (a - b));
}
